


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';

// Constants
import Assets from '@/constants/assets.ts';

// Views
import FormView from '@/shared/views/form.view.vue';
import ConvocationInfo from '@/clickbuy/purchase/views/convocation-info.view.vue';
import DownloadView from '@/clickbuy/purchase/views/download-view/index.vue';
import { mapGetters } from 'vuex';

// Components
import Input, {
    InputType,
    InputStyle,
} from '@/shared/components/input.component.vue';
import Field from '@/shared/components/field.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import Checkbox, { CheckboxPredefinedStyle } from '@/shared/components/checkbox.component.vue';
import Btn, { BtnPredefinedStyle, BtnColor } from '@/shared/components/btn.component.vue';
import ItemThumb, { ItemThumbPrefeginedStyle } from '@/shared/components/item-thumb.component.vue';

// Models
import { Purchase, PaymentMethod, PurchaseCompletionStatus } from '@/clickbuy/purchase/models/purchase.model.ts';
import { Participant } from '@/manager/convocation/participant.model';
import { Bill } from '@/clickbuy/purchase/models/bill.model';
import { Companion } from '@/clickbuy/purchase/models/companion.model';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';

// Services
import UtilsService from '@/core/services/utils.service';

// interface MixinInterface extends ErrorMixin {}

@Component({
    components: {
        Btn,
        Checkbox,
        ConvocationInfo,
        Field,
        FieldSet,
        FormView,
        Input,
        ItemThumb,
        DownloadView,
    },
    computed: {
        ...mapGetters({
            getCompanion: 'getCompanion',
        }),
    },
})
export default class CompanionForm extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop() private companionId!: string;


    private assets = Assets;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private checkboxPredefinedStyle = CheckboxPredefinedStyle;
    private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
    private btnColor = BtnColor;
    private inputType = InputType;
    private inputStyle = InputStyle;
    private nifMask = '';
    private getCompanion!: any;
    private companionLoaded = false;
    private dataProtection = false;
    private dataProtectionUrl = 'https://www.levelupdesarrollo.com/politica-de-privacidad-level-up/';
    private companion = new Companion();
    private billDataCollapsed = true;


    @Watch('companion.client.user.profile.nif')
    private watchNif(newVal: string, oldVal: string) {
        this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
    }


    private created() {
        this.fetchCompanion(() => {
            this.companion = this.getCompanion(this.companionId);
            this.companionLoaded = true;
        });
    }

    private mounted() {
        this.setScrollParentNode();
    }


    get showDownloadView() {
        return this.companionLoaded && this.companion.completionStatus === PurchaseCompletionStatus.Finished;
    }

    get showFormView() {
        return this.companionLoaded && this.companion.completionStatus === PurchaseCompletionStatus.Pending;
    }

    get formComplete() {
        return (
            (this.companion.client as any).user.firstName !== '' &&
            (this.companion.client as any).user.secondName !== '' &&
            (this.companion.client as any).user.profile.nif !== '' &&
            (this.companion.client as any).user.email !== '' &&
            (this.companion.client as any).user.profile.phone !== '' &&
            (this.companion.client as any).user.profile.address !== '' &&
            (this.companion.client as any).user.profile.postalCode !== '' &&
            (this.companion.client as any).user.profile.town !== ''
        );
    }


    private setScrollParentNode() {
        this.parentNode = document.getElementsByClassName('form-view__content')[0];
    }

    private fetchCompanion( callback = () => { const doNothing = 1; } ) {
        this.$store.dispatch('fetchCompanion', { id: this.companionId })
            .then(() => {
                callback();
            });
    }

    private setCompanionFormError(err: any) {
        const serverError = err.response.data;
        this.error = { ...this.error, ...serverError };
    }

    private hasMandatoryFieldsErrors() {
        let hasError = false;

        if ( !this.dataProtection ) {
            const elementToScroll = ((this.$refs.dataProtection as any).$el as HTMLElement);
            this.$set(this.error , 'dataProtection', 'error');
            this.scrollTo(elementToScroll);
            hasError = true;
        }

        return hasError;
    }

    private sendForm() {
        if (!this.hasMandatoryFieldsErrors()) {

            const companion = Object.assign({}, this.companion);

            companion.completionStatus = PurchaseCompletionStatus.Finished;

            this.$store.dispatch('updateCompanion', { ...companion })
                .then(
                    (res) => {
                        // Éxito
                        this.companion = this.getCompanion(this.companionId);
                    },
                    (err) => {
                        this.setCompanionFormError(err);
                    },
                );

        }
    }
}

